import React from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@awesome.me/kit-70c1f0055f/icons/classic/light";

interface AccordionProps {
  isExpanded: boolean;
  onToggle: () => void;
  header: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
  testId?: string;
  toggleTestId?: string;
  /** Flush rail / list embedding — no outer border or corner radius. */
  borderless?: boolean;
}

export function Accordion({
  isExpanded,
  onToggle,
  header,
  children,
  className = "",
  headerClassName = "",
  contentClassName = "",
  testId,
  toggleTestId,
  borderless = false,
}: AccordionProps) {
  return (
    <div
      className={clsx(
        borderless
          ? "rounded-none border-0"
          : "rounded-lg border border-slate-200 dark:border-slate-700",
        className,
      )}
      data-testid={testId}
    >
      <button
        type="button"
        aria-expanded={isExpanded}
        data-testid={toggleTestId}
        className={clsx(
          "flex w-full items-center justify-between px-4 py-3 text-left transition-colors hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400/30 dark:hover:bg-slate-800",
          headerClassName,
        )}
        onClick={onToggle}
      >
        <div className="min-w-0 flex-1">{header}</div>
        <div className="ml-2 shrink-0">
          <FontAwesomeIcon
            icon={isExpanded ? faChevronDown : faChevronRight}
            className="h-4 w-4 text-slate-500 dark:text-slate-400"
          />
        </div>
      </button>
      {isExpanded ? (
        <div
          className={clsx(
            "border-t border-slate-200 p-4 dark:border-slate-700",
            contentClassName,
          )}
        >
          {children}
        </div>
      ) : null}
    </div>
  );
}
